import { css } from '@emotion/css';

export const tenantCreatedStepClassName = css({});
